import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Image, Row } from 'react-bootstrap';
import { IoIosArrowDown } from 'react-icons/io';
import { BiUserCircle } from 'react-icons/bi';
import { RiShieldKeyholeLine } from 'react-icons/ri';
import { MdLogout } from 'react-icons/md';
import InstituteLogo from 'assets/images/institute-logo.png';
import { HDivider } from 'components/CommonWidgets';
import { TransparentButton } from 'components/CustomForm';
import { useDispatch, useSelector } from 'react-redux';
import useScreen from 'hooks/useScreen';
import { device, matchMaxTablet } from 'helpers/screen';
import { toggleDimScreen } from 'redux/global.slice';
import { GlobalContext } from 'context/GlobalContext';
import { useLocation, useNavigate } from 'react-router-dom';

const Holder = styled.div`
    background-color: #0278EE;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 2rem;

    @media ${device.max.tablet} {        
        flex-direction: column;
        gap: 1rem;
	}

    & > div {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.user-section {
            position: relative;            
        }
    }    
`;

const Label = styled.span`
    color: white;
    font-size: ${(props) => props.fontSize ? props.fontSize : 11}pt;
    font-weight: ${(props) => props.bold ? '900' : '500'};
`;

const MainTitle = styled(Label)`
    width: 100%;
    text-align: center;
    z-index: 1;
`;

const ContextMenu = styled.div`
    position: absolute;
    width: 10rem;
    top: 1.7rem;
    left: 0;
    padding: 1rem;
    z-index: 333;
    border-radius: 4px;
    box-shadow: 1px 4px 8px 0px #424242;
    display: ${(props) => props.show ? 'flex' : 'none'};
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    background-color: white;

    & > div {
        width: 100%;
        display: flex;
        justify-content: end;
    }
`;

const Topbar = () => {
    const { logout: doLogout } = useContext(GlobalContext);
    const [isMenuVisible, setMenuVisibility] = useState(false);

    const globalState = useSelector((store) => store.global);
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const { pathname } = useLocation();

    const { size, lessThan900 } = useScreen();

    useEffect(() => {
        setMenuVisibility(globalState.dimScreen);
    }, [globalState.dimScreen]);

    const logout = () => {
        dispatch(toggleDimScreen());
        dispatch(doLogout())
    };

    const changePassword = () => {
        dispatch(toggleDimScreen());
        navigate('/change-password', { state: { from: pathname } });
    };
    
    const getUserFullName = () => {
        const fullName = localStorage.getItem('user_full_name');    
        return fullName || '';
    };

    return (
        <Holder>
            <div className='user-section'>
                <TransparentButton onClick={() => dispatch(toggleDimScreen())}>
                    <IoIosArrowDown size={24} color='white' />
                </TransparentButton>
                <Label className='mx-3'>{getUserFullName()}</Label>
                <BiUserCircle size={28} color='white' />
                <ContextMenu show={isMenuVisible}>
                    <div onClick={() => changePassword()}>
                        <span>تغییر رمز ورود</span>
                        <RiShieldKeyholeLine size={20} color='#000' className='ms-2' />
                    </div>
                    <HDivider className='my-2 w-75' />
                    <div onClick={() => logout()}>
                        <span>خروج</span>
                        <MdLogout size={20} color='#000' className='ms-2' />
                    </div>
                </ContextMenu>
            </div>
            <MainTitle bold fontSize='20'>سامانه مدیریت نهاده ها</MainTitle>
            <Image width={82} height={82} src={InstituteLogo} />
        </Holder>
    );
};

export default Topbar;